import { getAllInitResources } from "../api/requests";
import { IHomeServerProps } from "../resources/interfaces";
import { showToast } from "../utils/miscFunctions";

function useResource() {

    const getInitResources = async (): Promise<IHomeServerProps> => {
        let result: any = {};
        try {
          result = await getAllInitResources();
        } catch (error) {
          console.debug(error);
        }
    
        return {
          supportedVehicles: result?.data?.supportedVehicles ?? [],
          vehicleUsages: result?.data?.vehicleUsages ?? {},
          protectionTypes: result?.data?.protectionTypes ?? {},
          employerTypes: result?.data?.employerTypes ?? {},
          occupationTypes: result?.data?.occupationTypes ?? {},
          vehicleMakes: result?.data?.vehicleMake ?? [],
          insurers: result?.data?.insurers ?? [],
        };
      };
    
    const getVehicleMakes = (): Promise<any> => {
        return new Promise<any>((resolve, reject) => {
            getAllInitResources()
                .then((response: any) => {
                    resolve(response?.data?.vehicleMake);
                }).catch((error: Error) => {
                    reject(error);
                });
        });
    }

    const shareContennt = async (data: {title?: string, text?: string, url: string}) => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: data.title,
                    text: data.text,
                    url: data.url
                });
            } catch (error) { }
        } else {
            try {
                await navigator.clipboard.writeText(data.url);
                showToast.success('URL copied to clipboard');
            } catch (error) {
                // console.error('Clipboard copy failed:', error);
            }
        }
    };

    return { getInitResources, getVehicleMakes, shareContennt };
}

export default useResource;